export default __webpack_public_path__ + "static/media/PROTOCOLLI_ICONA.564e1a86.svg";